/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { ICON_WIDGETS_WITH_ADD_CIRCLE, SdsIcon } from '@squiz/sds';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { AddComponentToSet } from '../../../../../../Components/AddComponentToSet/AddComponentToSet';
import { COMPONENT_SERVICE_STRINGS } from '../../../../../../Constants/Strings.constants';
import { COMPONENT_SET_DETAILS_DATA_IDS } from '../../../../ComponentSetDetails.constants';
import { ComponentSetDetailsComponentsProps } from '../../ComponentSetDetailsComponents.props';

/**
 * Component set details components empty state.
 */
export const ComponentsEmptyState = (props: ComponentSetDetailsComponentsProps): JSX.Element => {
  const { t } = useTranslation();
  const { webPath, updateComponentSetDetails } = props;

  const labels = {
    addToSet: t(COMPONENT_SERVICE_STRINGS.addToSet),
    noComponents: t(COMPONENT_SERVICE_STRINGS.noComponentsInSet),
    useTheButton: t(COMPONENT_SERVICE_STRINGS.useTheButtonBelow),
  };

  return (
    <div className="component-set-details__components-container-empty-state">
      <div className="component-set-details__components-icon" data-id={COMPONENT_SET_DETAILS_DATA_IDS.emptyStateIcon}>
        <SdsIcon svg={ICON_WIDGETS_WITH_ADD_CIRCLE} />
      </div>

      <div className="component-set-details__components-content">
        <h4 className="component-set-details__components-content-title">{labels.noComponents}</h4>
        <span className="component-set-details__components-content-desc">
          {labels.useTheButton} <strong>{labels.addToSet}</strong>
        </span>
      </div>

      <div className="component-set-details__components-button">
        <AddComponentToSet
          componentSetDisplayName={props.displayName}
          disabled={props.disabled}
          submitButtonText={labels.addToSet}
          updateComponentSetDetails={updateComponentSetDetails}
          webpath={webPath}
        />
      </div>
    </div>
  );
};
